import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { returnNetwork } from "../../utils/NetworkFunctions.js";
import progress from "../../assets/images/block_search.gif";
import { getConfirmationsByCryptoNetwork } from "../../utils/cryptoCurrenciesUtils.js";

const CheckDeposit = ({ cryptoCurrency, network, title, address, setStep, deposit }) => {
	const [documentId, setDocumentId] = useState("");

	let isMobile = false;

	if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
		isMobile = true;
	}

	return (
		<Grid sx={{ width: isMobile ? "100%" : 500 }}>
			<Card>
				<CardContent>
					<Box sx={{ marginTop: 2 }}>
						<Typography component="h2" variant="h6" sx={{ mb: 2 }}>
							{title}
						</Typography>
					</Box>
					<Box sx={{ marginTop: 2 }}>
						<Typography color="primary" sx={{ fontSize: "18px", fontWeight: "bold" }} gutterBottom>
							{`${cryptoCurrency} ${returnNetwork(network, cryptoCurrency)} Network`}
						</Typography>
					</Box>
					<Box sx={{ marginTop: 2 }}>
						<img src={progress} />
					</Box>
					<Box sx={{ marginTop: 2 }}>
						<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "green" }} gutterBottom>
							{`Verifying your Deposit...`}
						</Typography>
					</Box>
					{deposit?.depositDocumentNumber ? (
						<Box sx={{ marginTop: 2 }}>
							<Typography color="primary" sx={{ fontSize: "17px", fontWeight: "bold" }} gutterBottom>
								{`Transaction ID:  ${deposit?.depositDocumentNumber}`}
							</Typography>
						</Box>
					) : null}
					{deposit?.confirmations ? (
						<Box sx={{ marginTop: 2 }}>
							<Typography color="primary" sx={{ fontSize: "17px", fontWeight: "bold" }} gutterBottom>
								{`Confirmations:  ${deposit?.confirmations}/${getConfirmationsByCryptoNetwork(cryptoCurrency, network)}`}
							</Typography>
						</Box>
					) : null}

					<Box sx={{ textAlign: "justify", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
						<Typography sx={{ fontSize: "12px", fontWeight: "bold" }} gutterBottom>
							{`Your account balance will be credited once deposit verification has completed`}
						</Typography>
					</Box>
					<Box sx={{ textAlign: "justify", marginTop: 2, paddingLeft: 3, paddingRight: 3, paddingBottom: 4 }}>
						<Typography sx={{ fontSize: "12px", fontWeight: "bold" }} gutterBottom>
							{`Please save the transaction id number in case you require customer support.`}
						</Typography>
					</Box>
				</CardContent>
			</Card>
		</Grid>
	);
};

export default CheckDeposit;
